
import React from 'react';
import { PageLayout } from '@/components/layout';
import QuickRecipeForm from '@/components/recipe/QuickRecipeForm';

const CreateQuickRecipe = () => {
  return (
    <PageLayout 
      title="Create Quick Recipe"
      description="Create a simple recipe with minimal effort"
    >
      <div className="container pb-14">
        <QuickRecipeForm />
      </div>
    </PageLayout>
  );
};

export default CreateQuickRecipe;
